import React from 'react';
import { useSelector } from 'react-redux';
import { useIsSmallAndAbove } from '../../hooks/mediaQueries';
import { isAcceptedRegion } from '../../utilities/locale-utilities';
import DeliveryNote from './DeliveryNote@default';
import FinanceExample from './FinanceExample/FinanceExample';
import PageInformation from './PageInformation';
import Pagination from './Pagination';
import SeoContentBlock from './SeoContentBlock';

export const ListerFooter = () => {
	const isSmallAndAbove = useIsSmallAndAbove();

	const { loading } = useSelector((state) => state);

	return (
		<React.Fragment>
			<footer
				className="flex flex-col justify-center items-center text-center md:px-2 md:pt-8 pb-8"
				data-testid="responsive-footer"
				data-tag-section="lister footer">
				{isSmallAndAbove && (
					<React.Fragment>
						<Pagination />
						<PageInformation />
					</React.Fragment>
				)}

				{!loading &&
					(isAcceptedRegion(['AOL']) ? (
						<React.Fragment>
							<FinanceExample />
							<DeliveryNote />
						</React.Fragment>
					) : (
						isSmallAndAbove && <DeliveryNote />
					))}
			</footer>

			<div id="qubit-recently-viewed"></div>

			{isAcceptedRegion(['AOL']) && <SeoContentBlock />}
		</React.Fragment>
	);
};

export default ListerFooter;
